<nz-page-header nzTitle="个人资料">
  <!--  <nz-breadcrumb nz-page-header-breadcrumb>-->
  <!--    <nz-breadcrumb-item>首页</nz-breadcrumb-item>-->
  <!--    <nz-breadcrumb-item>个人资料</nz-breadcrumb-item>-->
  <!--  </nz-breadcrumb>-->
</nz-page-header>

<div class="p-md">
  @if (isHasMsg) {
    <nz-alert [nzType]="'warning'" [nzMessage]="noSubjectMsg" [nzShowIcon]="'true'"></nz-alert>
  }
  <nz-card>
    <form nz-form [formGroup]="form">
      <nz-form-item>
        <nz-form-label nz-col [nzSm]="4" nzRequired>用户名</nz-form-label>
        <nz-form-control nz-col [nzSm]="6">
          <input nz-input formControlName="username" readonly />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nz-col [nzSm]="4" nzRequired>真实姓名</nz-form-label>
        <nz-form-control
          nz-col
          [nzSm]="6"
          nzHasFeedback
          [nzValidateStatus]="getFormControl('firstName')"
          [nzErrorTip]="firstNameTpl"
        >
          <input nz-input formControlName="firstName" />
          <ng-template #firstNameTpl let-control>
            @if (hasError('firstName', 'required')) {
              请填写真实姓名.
            }
            @if (hasError('firstName', 'minlength') || hasError('firstName', 'maxlength')) {
              真实姓名必须是2-10个字符。
            }
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item nz-row>
        <nz-form-label nz-col [nzSm]="4">密码</nz-form-label>
        <div nz-col [nzSm]="6">
          <nz-form-control nzHasFeedback [nzValidateStatus]="getFormControl('password')" [nzErrorTip]="passwordTpl">
            <input nz-input type="password" formControlName="password" />
            <ng-template #passwordTpl let-control>
              @if (hasError('password', 'pattern')) {
                <ng-container class="text-red"> 密码必须至少6个字符</ng-container>
              }
            </ng-template>
          </nz-form-control>
          <div class="text-grey-dark">如果不修改密码, 请不要填写.</div>
        </div>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSm]="4">确认密码</nz-form-label>
        <nz-form-control
          nz-col
          [nzSm]="6"
          nzHasFeedback
          [nzValidateStatus]="getFormControl('password2')"
          [nzErrorTip]="password2Tpl"
        >
          <input nz-input type="password" formControlName="password2" />
          <ng-template #password2Tpl let-container>
            @if (hasError('password2', 'equals')) {
              <ng-container class="text-red">确认密码与输入密码不匹配.</ng-container>
            }
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      @if (userInfo?.phone) {
        <nz-form-item>
          <nz-form-label [nzSm]="4">手机号</nz-form-label>
          <nz-form-control nz-col [nzSm]="6" nzHasFeedback [nzValidateStatus]="getFormControl('phone')">
            <input nz-input formControlName="phone" />
          </nz-form-control>
          <button flCheckLoginType nz-button nzType="link" enhanceClick (click.throttle)="changePhone()">
            更换手机号
          </button>
        </nz-form-item>
      }

      <nz-form-item>
        <nz-form-label nz-col [nzSm]="4" nzRequired>任教阶段</nz-form-label>
        <nz-form-control nz-col [nzSm]="6">
          <nz-select
            style="width: 120px"
            formControlName="grade"
            nzAllowClear
            (ngModelChange)="onGradeChange($event)"
            [nzShowSearch]="true"
            [nzDisabled]="disableFixSubject()"
            nzPlaceHolder="尚未选择"
          >
            @for (grade of gradeList; track grade) {
              <nz-option [nzLabel]="grade.name" [nzValue]="grade.gradeId"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item nz-row>
        <nz-form-label nz-col [nzSm]="4" nzRequired>任教科目</nz-form-label>
        <nz-form-control nz-col [nzSm]="6">
          <nz-select
            style="width: 120px"
            formControlName="subjectId"
            nzPlaceHolder="尚未选择"
            [nzShowSearch]="true"
            [nzDisabled]="disableFixSubject()"
            nzAllowClear
          >
            @for (subject of subjectList; track subject) {
              <nz-option [nzLabel]="subject.name" [nzValue]="subject.id"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item nz-row>
        <nz-form-control nz-col [nzSpan]="10" [nzOffset]="4">
          <button flCheckLoginType (click)="onSubmit()" nz-button [nzSize]="'large'" nzType="primary">保存</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </nz-card>
</div>
